import React from "react";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import AdminNavbar from "./AdminNavbar";

const AdminLayout: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: false,
      mirror: true,
      easing: "ease-in-out",
    });
  }, []);

  return (
    <div>
      {/* Navbar stays on top */}
      <AdminNavbar />

      {/* This is where child routes render */}
      <div className="bg-[#F5F3F0] pt-[10vh]">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
